var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ForkLift50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M27 36A4 4 0 1 0 27 44A4 4 0 1 0 27 36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M19,28l-2.8-2.8c-0.8-0.8-1.8-1.2-2.8-1.2H5v16h26V30l-3-2H19z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M9 36A4 4 0 1 0 9 44 4 4 0 1 0 9 36zM27 36A4 4 0 1 0 27 44 4 4 0 1 0 27 36z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M35.4 40L45 40 45 36 38.4 36 30.4 4 26.4 4zM30 25.3L21.9 9.1C21 7.2 18.9 6 16.7 6H9c-2.3 0-4 1.7-4 4v14h4V10l0 0h7.7c.7 0 1.4.4 1.6.9l8.1 16.2c.1.3.3.6.3.9H28l3 2v-.2C31 28.1 30.7 26.7 30 25.3zM27 38A2 2 0 1 0 27 42 2 2 0 1 0 27 38zM9 38A2 2 0 1 0 9 42 2 2 0 1 0 9 38z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ForkLift50);
export default __webpack_public_path__ + "static/media/icons8-fork-lift-50.f0fc01d2c2f88e138733f996d9e589f9.svg";
export { ForwardRef as ReactComponent };